export default "__VITE_PUBLIC_ASSET__bb22a689__"